<template>
  <v-container fill-height fluid grid-list-lg class="py-2 px-3">
    <v-layout row wrap>
      <v-flex xs12 md4 lg3 :style="{height:blockHeight, 'overflow-y':'auto'}" class="treeblock">
        <div class="text-sm-center">
          <v-progress-circular
            indeterminate
            color="primary"
            v-if="disks === []"
          ></v-progress-circular>
        </div>
        <FolderItem v-for="disk in disks" 
          :key="disk.id" 
          :id="disk.id" 
          :authorised="disk.authorised"
          :label="disk.label"
          :diskType="disk.type"
          :getFolderContent="getFolderContent" 
          :getIcon="getIcon" 
          :getShareIcon="getShareIcon"
          :showScopes="showScopes"
          :renameElement="renameElement"
          :clickAction="clickAction"
          :openHistoryForm="openHistoryForm"
          @deleteElementEmit='deleteElementEmit'
          @pushToTrash="pushToTrash"
          @pushFolderToTrash="pushFolderToTrash"
          @makeCurrentElement="makeCurrentElement"
          @letData="letData"
          @itemClickEmit="itemClickEmit"
          />

        <v-card class="mt-3">
          <v-card-title class="pa-0">
            <v-system-bar color="accent" dark window style="width: 100%">
              <v-btn flat @click="expanded.shared=!expanded.shared">Доступные мне<v-icon>{{expanded.shared?'mdi-chevron-up':'mdi-chevron-down'}}</v-icon></v-btn>
            </v-system-bar>
            <input style="display: none;" type="file" ref="file" @change="onChangeInputFile">
          </v-card-title>
          <v-card-text class="px-0 py-2 overflow-auto" v-show="expanded.shared">
            <v-treeview :items="shared_files" class="densed pb-1" activatable item-key="key" :load-children="getFolderContent">
              <template slot="prepend" slot-scope="{ item, open }">
                <v-icon v-if="!item.mime" size="20"> {{ open ? 'mdi-folder-open' : 'mdi-folder' }}</v-icon>
                <v-icon v-else size="20"> {{ getIcon(item.mime) }}</v-icon>
                <v-icon size="16" class="ml-1 pointer" @click="showScopes(item)">{{getShareIcon(item)}}</v-icon>
              </template>
              <label slot="label" class="pointer" slot-scope="{item}" @click="itemClick(item, false, 'shared')"
                     @contextmenu.prevent="openCtxMenu(item, 'shared')">{{item.name}}</label>
            </v-treeview>
          </v-card-text>
        </v-card>
  
        <v-card class="mt-3">
          <v-card-title class="pa-0">
            <v-system-bar color="accent" dark window style="width: 100%">
              <v-btn flat @click="expanded.trash=!expanded.trash">Корзина<v-icon>{{expanded.trash?'mdi-chevron-up':'mdi-chevron-down'}}</v-icon></v-btn>
              <v-spacer></v-spacer>
              <v-tooltip top>
                <v-btn slot="activator" icon @click="deleteTrash">
                  <v-icon class="mx-0 white--text">mdi-delete</v-icon>
                </v-btn>
                <span>Очистить корзину</span>
              </v-tooltip>
            </v-system-bar>
          </v-card-title>
          <v-card-text class="px-0 py-2 overflow-auto" v-show="expanded.trash">
            <v-treeview :items="trashed_files" class="densed pb-1" activatable item-key="key" :load-children="getTrashDirectoryContent">
              <template slot="prepend" slot-scope="{ item, open }">
                <v-icon v-if="!item.mime" size="20"> {{ open ? 'mdi-folder-open' : 'mdi-folder' }}</v-icon>
                <v-icon v-else size="20"> {{ getIcon(item.mime) }}</v-icon>
                <v-icon size="16" class="ml-1 pointer" @click="showScopes(item)">{{getShareIcon(item)}}</v-icon>
              </template>
              <label slot="label" class="pointer" slot-scope="{item}" @click="itemClick(item, false, 'trashed')"
                     @contextmenu.prevent="openCtxMenu(item, 'trashed')">{{item.name}}</label>
            </v-treeview>
          </v-card-text>
        </v-card>
      </v-flex>
      
      <v-flex xs12 md8 lg9 :style="{height:blockHeight, 'overflow-y':'auto', position: 'relative'}">
        <v-card style="height: 100%; overflow-y: auto">
          <v-system-bar color="accent" dark window style="width: 100%">
            <v-icon center>mdi-folder-open</v-icon>
            <v-toolbar-title class="ml-1">Папки и файлы</v-toolbar-title>
            <v-spacer></v-spacer>
            <template v-if="editFile || (preview && previewElement)">
              <v-tooltip top v-if="tipTapAccountsIds.includes(accountId)">
                <v-btn icon slot="activator" @click="() => changeEditor()" class="mx-0">
                  <v-icon v-if="!newEditor"class="mx-0 white--text">mdi-checkbox-blank-outline</v-icon>
                  <v-icon v-if="newEditor"class="mx-0 white--text">mdi-checkbox-marked-outline</v-icon>
                </v-btn>
                <span>Включить новый редактор</span>
              </v-tooltip>
              <v-tooltip top v-if="currentElement && currentElement.writable">
                <v-btn small icon slot="activator" @click="openHistoryForm" class="mr-1"><v-icon class="mx-0">mdi-history</v-icon></v-btn>
                <span>История изменений</span>
              </v-tooltip>
              <v-tooltip top>
                <v-btn small icon slot="activator" @click="showScopes(currentElement)" class="mr-1"><v-icon class="mx-0">mdi-sitemap</v-icon></v-btn>
                <span>Совместный доступ</span>
              </v-tooltip>
              <v-tooltip top v-if="currentElement && currentElement.writable">
                <v-btn small icon slot="activator" @click="openEditForm(true)" class="mr-0"><v-icon class="mx-0">mdi-settings</v-icon></v-btn>
                <span>Настройки</span>
              </v-tooltip>
            </template>
          </v-system-bar>
          <v-flex xs12 class="breadcrumbs-block pb-0">
            <v-btn-toggle v-show="!preview && !editFile" v-model="view_mode" mandatory class="pull-left mr-3">
              <v-btn small flat>
                <v-icon small>mdi-view-headline</v-icon>
              </v-btn>
              <v-btn small flat>
                <v-icon small>mdi-view-grid</v-icon>
              </v-btn>
            </v-btn-toggle>
            <ul class="dms-breadcrumb">
              <li v-for="(crumb, index) in breadCrumbs" :key="index"><a @click="navigateCrumb(index)">{{crumb.name}}</a></li>
            </ul>
          </v-flex>
          <v-flex xs12 class="text-xs-center py-5" v-if="loading">
            <p>Загрузка ...</p>
            <v-progress-circular :size="70" :width="7" indeterminate color="primary"></v-progress-circular>
          </v-flex>
          <template v-else>
            <v-flex xs12 v-if="editFile && currentElement">
              <v-layout row wrap>
                <v-flex xs12 sm8 md6 class="pt-0 mb-2">
                  <v-text-field label="Название заметки" @blur="saveFileName" v-model="currentElement.name" hide-details></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 offset-md2 md4 class="py-0 text-xs-right">
                  <v-btn color="success" small @click="saveContent(false)" :disabled="!maySave">Сохранить</v-btn>
                  <p class="ma-0 pr-2" v-show="showSavedMessage">Файл сохранен</p>
                </v-flex>
                <v-flex xs12 class="text-xs-right" v-if="connectedUsers">
                  <span class="subheading">Файл редактируют: </span>
                  <v-tooltip top v-for="(user, index) in connectedUsers" :key="index">
                    <img slot="activator" style="border-radius: 20px; width: 30px; height: 30px" :src="user.avatar">
                    <span>{{user.name}}</span>
                  </v-tooltip>
                </v-flex>
              </v-layout>
              <dantser-editor v-if="!newEditor" @onChange="contentChanged" @onKeyDown="keyDown" @onKeyUp="keyUp" @onMouseUp="mouseUp" @onNodeChange="nodeChange"
                              @onPaste="onPaste" @onExecCommand="execCommand" @onBeforeExecCommand="beforeExecCommand" v-model="fileContent" :init="editorBaseConfig" :api-key="editorApiKey" ref="editor"></dantser-editor>
              <tiptap-editor v-if="newEditor" v-model="fileContent" @editorUpdated="tipTapContentChanged"></tiptap-editor>
            </v-flex>
            <template v-else>
              <v-flex xs12 v-if="preview && previewElement" style="height:calc(100% - 80px)">
                <file-viewer :data="previewElement" @destroy="clearPreview"></file-viewer>
              </v-flex>
              <v-flex xs12 v-else-if="!preview && view_mode===0" class="pt-0" style="height: 100%; overflow-y: auto">
                <v-data-table id="disk-files-table" :headers="headers" :items="folderContent" hide-actions item-key="key" disable-initial-sort>
                  <template slot="headerCell" slot-scope="props">
                    <v-icon v-if="props.header.icon" size="18">{{props.header.icon}}</v-icon>
                    <span v-else>{{ props.header.text }}</span>
                  </template>
                  <template slot="items" slot-scope="props">
                    <td>
                      <a><v-icon size="16" @click="showScopes(props.item)">{{getShareIcon(props.item)}}</v-icon></a></td>
                    <td>
                  <span class="pointer" @click="itemClick(props.item, true)" @contextmenu.prevent="openCtxMenu(props.item)">
                    <v-icon v-if="!props.item.mime" size="20">mdi-folder</v-icon>
                    <v-icon v-else size="20">{{ getIcon(props.item.mime) }}</v-icon>
                    {{ props.item.name }}
                  </span>
                    </td>
                    <td class="text-xs-center">{{ formatFileSize(props.item.size) }}</td>
                    <td class="text-xs-center">
                      <v-tooltip top>
                        <span slot="activator">{{ props.item.owner.name }}</span>
                        <span>{{ props.item.owner.fullname }}</span>
                      </v-tooltip>
                    </td>
                    <td class="text-xs-center">{{ formatDatetime(props.item.created_at).middle }}</td>
                    <td class="text-xs-center">{{ formatDatetime(props.item.updated_at).middle }}</td>
                  </template>
                  <td slot="no-data" :colspan="headers.length" class="text-xs-center">(пусто)</td>
                </v-data-table>
              </v-flex>
              <v-flex xs12 v-else-if="!preview && view_mode===1" style="height:100%; overflow-y: auto;" class="pb-3">
                <template v-if="folderContent.length>0">
                  <div class="dms-disk-file" v-for="item in folderContent" :key=item.key @click="itemClick(item, true)" @contextmenu.prevent="openCtxMenu(item)">
                    <div class="disk-file-icon">
                      <v-icon v-if="!item.mime">mdi-folder</v-icon>
                      <v-icon v-else>{{ getIcon(item.mime) }}</v-icon>
                    </div>
                    <div class="disk-file-name"><p>{{item.name}}</p></div>
                  </div>
                </template>
                <div v-else class="text-xs-center">
                  <p>(пусто)</p>
                </div>
              </v-flex>
            </template>
          </template>
        </v-card>
      </v-flex>
    </v-layout>
    
    <v-dialog v-model="dialog" max-width="1000" scrollable persistent>
      <component :is="currentComponent" v-if="dialog" v-bind="formProps" @close-dialog="dialog=false" @save="saveDialog"></component>
    </v-dialog>
    
    <v-dialog v-model="loadingDialog" persistent max-width="600">
      <v-card class="pa-4 text-xs-center">
        <p>Загрузка файла</p>
        <v-progress-linear indeterminate></v-progress-linear>
        <v-btn small color="error" @click="cancelFileUploading">Отменить</v-btn>
      </v-card>
    </v-dialog>
    
    <context-menu id="disk-context-menu" ref="ctxMenu">
      <li @click="openInfoForm"><v-icon size="18">mdi-information</v-icon> Информация</li>
      <li @click="restoreElement" v-if="currentTree==='trashed' && currentElement && currentElement.writable"><v-icon size="18">mdi-restore</v-icon> Восстановить</li>
      <li @click="renameElement" v-if="currentTree!=='trashed' && currentElement && currentElement.writable"><v-icon size="18">mdi-cursor-text</v-icon> Переименовать</li>
      <li @click="openEditForm(true)" v-if="currentTree!=='trashed' && currentElement && currentElement.writable"><v-icon size="18">mdi-settings</v-icon> Настройки</li>
  
      <li @click="addElement($event, 'folder', currentElement.id, currentTree)" v-if="elementType==='folder' && currentTree!=='trashed' && currentElement && currentElement.writable"><v-icon size="18">mdi-folder-plus</v-icon> Добавить папку</li>
      <li @click="addNote(currentElement.id, currentTree)" v-if="elementType==='folder' && currentTree!=='trashed' && currentElement && currentElement.writable"><v-icon size="18">mdi-file-plus</v-icon> Создать заметку</li>
      <li @click="selectInputFile(currentTree)" v-if="elementType==='folder' && currentTree!=='trashed' && currentElement && currentElement.writable"><v-icon size="18">mdi-cloud-upload</v-icon> Загрузить файл</li>
      
      <li @click="previewFile" v-if="elementType==='file'"><v-icon size="18">mdi-eye</v-icon> Просмотр</li>
      <li @click="downloadFile" v-if="elementType==='file'"><v-icon size="18">mdi-download</v-icon> Скачать</li>
      <li @click="deleteElement" v-if="currentElement && currentElement.writable"><v-icon size="18">mdi-delete</v-icon> Удалить</li>
    </context-menu>
  
    <v-menu :close-on-content-click="false" v-model="menu.show" offset-y bottom absolute :position-x=position.x :position-y="position.y">
      <v-card>
        <v-card-text class="py-1">
          <v-text-field :label="elementType==='folder'?'Название папки':'Название файла'" hide-details clearable v-model="elementName" @keypress.enter="saveElement"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="menu.show = false" small>Отмена</v-btn>
          <v-btn color="success" dark @click="saveElement" :disabled="!elementName">Сохранить</v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  
  </v-container>
</template>

<script>
  import contextMenu from 'vue-context-menu'
  import { mapGetters, mapState } from 'vuex'
  import {getNodeByProp, deleteNodeByProp} from '@/helpers/tree'
  import Editor from '@tinymce/tinymce-vue';
  
  import InfoForm from './Forms/InfoForm'
  import FolderForm from './Forms/FolderForm'
  import ScopeForm from './Forms/ScopeForm'
  import HistoryForm from './Forms/HistoryForm'
  import FileViewer from '../FileViewer/FileViewer'
  import FolderItem from './FolderItem'
  
  import _ from 'lodash'
  import uuidv4 from 'uuid/v4'
  import httpClient from '@/api/http-client'
  
  const cancelToken = httpClient.cancelToken
  import apiDisk from '@/apps/disk/api'
  import TipTapEditor from "../../../../components/TipTapEditor";
  
  export default {
    name : "FoldersList",
    
    components : {
      contextMenu,
      FolderItem,
      FileViewer,
      'dantser-editor' : Editor,
      'tiptap-editor': TipTapEditor,
    },
    
    computed:{
      ...mapGetters('app/helpers',['formatDatetime']),
      ...mapState('disk', ['editorBaseConfig', 'editorApiKey']),
      ...mapGetters(`app/account`, ['userFullName', 'accountId']),
      ...mapGetters('app/org', ['getPostById']),
      curPost() {
        return this.$store.getters[`app/account/getPost`]()
      },
      shared_files: {
        get(){ return this.$store.getters['disk/shared_files'] },
        set(tree){ this.$store.commit('setSharedFiles', tree) }
      },
      trashed_files: {
        get(){ return this.$store.getters['disk/trashed_files'] },
        set(tree){ this.$store.commit('setTrashedFiles', tree) }
      },
      blockHeight(){
        return (this.$vuetify.breakpoint.height - 48 - 40 - 30 )+'px'
      },
    },
  
    data() {
      return {
        tipTapAccountsIds: ['d6198a3a-2de0-41a2-81da-3a946785a54e', 'bfc33865-9ed9-4628-bb73-67c48a9ebd31',
          'ff67390e-a8a4-46ad-b727-6279c77613c4', '82f21ab3-4e0b-48b8-b5a6-a470b71a0b67'],
        newEditor: false,
        formProps: {},
        dialog: false,
        data: [],
        currentComponent: null,
        currentElement: null,
        previewElement: null,
        currentTree: 'my',
        treeActive: [],
        treeOpen: [],
        expanded: {
          my: true,
          shared: false,
          trash: false
        },
        position: {x: null, y: null},
        menu: {
          show: false,
          action: null,
          folder_id: null
        },
        elementName: '',
        elementType: null,
        disks: [],
        folderContent: [],
        view_mode: 0,
        headers: [
          { icon: 'mdi mdi-eye', align: 'center', sortable: false, width: 20},
          { text: 'Название', align: 'left', value: 'name' },
          { text: 'Размер', align: 'center', value: 'size', width: 100 },
          { text: 'Владелец', align: 'center', sortable: false },
          { text: 'Дата создания',  align: 'center', value: 'created_at', width: 160 },
          { text: 'Дата обновления', align: 'center', value: 'updated_at', width: 160 },
        ],
        search : '',
        breadCrumbs : [],
        preview : false,
        editFile : false,
        maySave : false,
        fileContent : {},
        uploadPercentage : 0,
        loading : false,
        loadingDialog : false,
        cancelTokenSource : null,
        showSavedMessage : false,
        
        //socket collaborative
        offset: 0,
        rangeAncestor: null,
        node : null,
        enter: false,
        socket : null,
        contentSent: true,
        connectedUsers: null,
        socket_id: null,
        userCommand: true,
        itemId: null,
      }
    },
    
    created() {
      window.addEventListener( 'beforeunload', this.leaving )
      
      this.$store.dispatch( 'disk/volume' ).then( response => {
        this.disks = response
        this.makeBreadCrumbs( null )
        this.getOwners()
      } )
      this.$store.dispatch( 'disk/shared' )
      this.$store.dispatch( 'disk/trash' )
  
      this.saveContentDebounce = _.debounce(this.saveContent, 2000)
      
      this.sendContentThrottle = _.throttle( () => {
        let xpath = this.getXPathForElement(this.node)
        let data = `{"type":"insert_text", "xpath":"${xpath}", "content_type":"text" , "content":${JSON.stringify(this.node.innerHTML)}, "connection_id": "${this.socket_id}"}`
        this.sendContent(data, 'throttle')
      }, 1000 )
    },
    
    beforeRouteLeave( to, from, next ) {
      if( this.maySave ) {
        this.saveContent()
        next()
      } else {
        next()
      }
    },
    
    destroyed(){
      this.socket.close()
      window.removeEventListener('beforeunload', this.leaving )
    },
    
    methods:{
      changeEditor() {
        this.newEditor = !this.newEditor
      },
      showScopes(data){
        this.currentComponent = ScopeForm
        this.formProps = { data }
        this.dialog = true
      },
      
      itemClickEmit(data) {
        this.currentTree = ''
        this.itemClick(data.item, data.newCrumb, data.tree)
      },

      itemClick(item, newCrumb = false, treeType){
        if(this.maySave){
          this.saveContent()
        }
        this.clickAction(item, newCrumb, treeType)
      },
      
      clickAction(item, newCrumb = false, treeType){
        this.clearPreview()
        this.clearEdit()
        this.currentElement = item
        if(treeType) this.currentTree = treeType
  
        if(item.key.indexOf('directory')>-1){
          if(item.children.length===0){
            this.loading = true
            this.getFolderContent(item).then(_=>{
              this.folderContent = item.children
              if(newCrumb){
                let i = this.breadCrumbs.length-1
                if(this.breadCrumbs[i].key!==item.key) this.breadCrumbs.push(item)
              } else {
                this.makeBreadCrumbs(item)
              }
              this.loading = false
              this.getOwners()
            })
          } else {
            this.folderContent = item.children
            if(newCrumb){
              this.breadCrumbs.push(item)
            } else {
              this.makeBreadCrumbs(item)
            }
            this.getOwners()
          }
        } else {
          // if has Access to write file and its type = text - Open editor, else - open file viewer
          this.$nextTick( function() {
            if( this.isFileEditable( item ) ) {
              this.loading = true
              this.editFile = true
              this.$store.dispatch( 'disk/getFileContent', item.id ).then( response => {
                this.fileContent = response
                this.itemId = item.id
                this.loading = false
                this.openSocketConnection( item.id )
              } )
            } else {
              this.loading = false
              this.preview = true
              this.previewElement = item
            }
      
            if(newCrumb){
              this.breadCrumbs.push(item)
            } else {
              this.makeBreadCrumbs(item)
            }
          })
        }
      },
      
      isFileEditable(item){
        return (this.currentTree!=='trashed' && item.writable && item.mime && item.mime.indexOf('text')>-1 && item.mime.indexOf('opendocument')<0 && item.mime.indexOf('rtf')<0)
      },
  
      saveContent(){
        if(this.maySave) {
          this.$store.dispatch('disk/saveFileContent', {id: this.currentElement.id, content: this.fileContent}).then(response => {
            this.showSavedMessage = true
            setTimeout(()=>{
              this.showSavedMessage = false
            }, 2000)
          })
        }
        this.maySave = false
      },
      
      openCtxMenu(item, treeType){
        if(treeType) this.currentTree = treeType
        this.currentElement = item
        this.treeActive = [item.key]
        this.elementType = (item.key.indexOf('directory')>-1) ? 'folder' : 'file'
        this.$refs.ctxMenu.open()
      },
      
      addNote(folder_id, treeType){
        this.currentTree = treeType
        this.elementName = 'Новая заметка от '+this.formatDatetime().short
        this.elementType = 'file'
        this.loading = true
        let tree = null
        switch(treeType){
          case 'my': tree = this.data; break
          case 'shared': tree = this.shared_files; break
          case 'trashed': tree = this.trashed_files; break
          default: tree = this.data; break
        }
        let node = getNodeByProp('key', 'directory_'+folder_id, tree)
        if(folder_id){
          this.getFolderContent(node).then( () => {
            this.createElement(folder_id, true)
            this.editFile = true
            this.fileContent = ''
          })
        } else {
          this.createElement(folder_id, true)
          this.editFile = true
          this.fileContent = ''
        }
      },
      
      addElement(event, type, folder_id = null, treeType){
        this.currentTree = treeType
        this.position = { x: event.x, y: event.y}
        this.elementName = (type==='folder') ? 'Новая папка' : 'Новая заметка от '+this.formatDatetime().short
        this.menu = {
          show: true,
          action: 'add',
          folder_id: folder_id
        }
        this.elementType = type
      },
  
      renameElement(event){
        this.position = { x: event.x-50, y: event.y-66}
        this.elementName = this.currentElement.name
        this.menu = {
          show: true,
          action: 'rename',
          folder_id: null
        }
      },
      
      saveElement(){
        switch(this.menu.action){
          case 'add':
            this.createElement(this.menu.folder_id)
            break
          case 'rename':
            this.updateName()
            break
        }
        this.menu.show = false
      },
  
      saveFileName(){
        let data = {
          id: this.currentElement.id,
          name: this.currentElement.name
        }
        this.$store.dispatch('disk/updateFile', data).catch( error => {
          this.$dmsErrorNoty('Возникла ошибка при попытке изменить имя')
        })
      },
      
      createElement(folder_id, makeCurrent = false){
        let tree = null
        switch(this.currentTree){
          case 'my': tree = this.data; break
          case 'shared': tree = this.shared_files; break
          case 'trashed': tree = this.trashed_files; break
          default: tree = this.data; break
        }
        
        if(this.elementType==='file'){
          let formData = new FormData();
          let blob = new Blob([""], { type: "text/html"});
          formData.append("file", blob);
          formData.append('name', this.elementName)
          formData.append('volume', this.currentElement.volume)
          if(folder_id) {
            formData.append('directory', folder_id)
          }
          this.$store.dispatch('disk/uploadFile', formData).then( response => {
            if(folder_id) {
              let node = getNodeByProp('key', 'directory_'+folder_id, tree)
              if(node!=null){
                node.children.push(response)
              }
            } else {
              tree.push(response)
            }
            if(makeCurrent) {
              this.currentElement = response
              this.treeActive = [response.key]
              this.treeOpen.push('directory_'+response.directory)
              this.makeBreadCrumbs(response)
            }
            this.loading = false
          }).catch( error => {
            this.loading = false
            this.$dmsErrorNoty('Возникла ошибка при попытке создать заметку')
          })
        } else {
          let data = { name: this.elementName, volume: this.currentElement.volume }
          if(folder_id) {
            data.parent = folder_id
          }
          this.$store.dispatch('disk/createFolder', data).then( response => {
            //Вставить папку после всех папок в корне или папке, перед файлами
            if(folder_id) {
              let node = getNodeByProp('key', 'directory_'+folder_id, tree)
              if(node!=null){
                let index = node.children.length
                node.children.some( (el, i) => {
                  if(el.key.indexOf('file')>-1){
                    index = i
                    return true
                  }
                })
                node.children.splice(index, 0, response)
              }
            } else {
              let index = tree.length
              tree.some( (el, i) => {
                if(el.key.indexOf('file')>-1){
                  index = i
                  return true
                }
              })
              tree.splice(index, 0, response)
            }
          }).catch( error => {
            this.$dmsErrorNoty('Возникла ошибка при попытке создать папку')
          })
        }
      },
      
      updateName(){
        let tree = null
        switch(this.currentTree){
          case 'my': tree = this.data; break
          case 'shared': tree = this.shared_files; break
          case 'trashed': tree = this.trashed_files; break
          default: tree = this.data; break
        }
        
        let data = {
          id: this.currentElement.id,
          name: this.elementName
        }
        
        if(this.elementType==='folder'){
          this.$store.dispatch('disk/updateFolder', data).then( _ => {
            let node = getNodeByProp('key', this.currentElement.key, tree)
            if(node) node.name = this.elementName
          }).catch( error => {
            this.$dmsErrorNoty('Возникла ошибка при попытке изменить имя')
          })
        } else if(this.elementType==='file'){
          this.$store.dispatch('disk/updateFile', data).then( _ => {
            let node = getNodeByProp('key', this.currentElement.key, tree)
            if(node) node.name = this.elementName
          }).catch( error => {
            this.$dmsErrorNoty('Возникла ошибка при попытке изменить имя')
          })
        }
      },
      
      deleteElementEmit(element) {
        if (this.previewElement) {
          if (element == this.previewElement.id) {  
            this.clearPreview()
            this.clearEdit()
            this.makeBreadCrumbs(null)
          }
        }
        if (this.itemId) {
          if (element === this.itemId) {
            this.clearPreview()
            this.clearEdit()
            this.makeBreadCrumbs(null)
          }
        }
      },

      deleteElement(){
        let tree = null
        switch(this.currentTree){
          case 'my': tree = this.data; break
          case 'shared': tree = this.shared_files; break
          case 'trashed': tree = this.trashed_files; break
          default: tree = this.data; break
        }
        
        if(this.elementType==='folder'){
          this.$dmsAgree('Вы действительно хотите удалить папку. Вложенные папки и файлы также будут удалены?').then(_ => {
            this.$store.dispatch('disk/deleteFolder', this.currentElement.id).then( _ => {
              let node = deleteNodeByProp('key', this.currentElement.key, tree)
              if(this.currentTree==='my' && node!=null) this.trashed_files.unshift(node)
            }).catch( error => {
              this.$dmsErrorNoty('Возникла ошибка при попытке удалить папку')
            })
          })
        } else if(this.elementType==='file'){
          this.$dmsAgree('Вы действительно хотите удалить файл?').then(_ => {
            if (this.previewElement) {
              if (this.currentElement.id == this.previewElement.id) {  
                this.clearPreview()
                this.clearEdit()
                this.makeBreadCrumbs(null)
              }
            }
            if (this.itemId) {
              if (this.currentElement.id === this.itemId) {
                this.clearPreview()
                this.clearEdit()
                this.makeBreadCrumbs(null)
              }
            }
            this.$store.dispatch('disk/deleteFile', this.currentElement.id).then( _ => {
              let node = deleteNodeByProp('key', this.currentElement.key, tree)
              if(this.currentTree==='my' && node!=null) this.trashed_files.push(node)
            }).catch( error => {
              this.$dmsErrorNoty('Возникла ошибка при попытке удалить файл')
            })
          })
        }
      },
  
      async getFolderContent(item) {
        if(this.currentTree==='trashed'){
          await this.$store.dispatch('disk/getTrashDirectoryContent', item.id).then( response => {
            let result = response.directories.concat(response.files)
            item.children = result
          })
        } else {
          await this.$store.dispatch('disk/getDirectoryContent', item.id).then( response => {
            let result = response.directories.concat(response.files)
            item.children = result
          })
        }
      },
      
      async getTrashDirectoryContent(item){
        await this.$store.dispatch('disk/getTrashDirectoryContent', item.id).then( response => {
          let result = response.directories.concat(response.files)
          item.children = result
        })
      },
  
      getIcon(mimeType){
        if(mimeType.indexOf('rtf')>-1) return 'mdi-file'
        if(mimeType.indexOf('text')>-1) return 'mdi-file-document-outline'
        if(mimeType.indexOf('image')>-1) return 'mdi-file-image'
        if(mimeType.indexOf('pdf')>-1) return 'mdi-file-pdf'
        if(mimeType.indexOf('audio')>-1) return 'mdi-file-music'
        if(mimeType.indexOf('video')>-1) return 'mdi-file-video'
        if(mimeType.indexOf('excel')>-1) return 'mdi-file-excel'
        if(mimeType.indexOf('msword')>-1) return 'mdi-file-word'
        if(mimeType.indexOf('zip')>-1) return 'mdi-zip-box'
        if(mimeType.indexOf('json')>-1) return 'mdi-json'
        return 'mdi-file'
      },
      
      getShareIcon(item){
        if(item.recursive) return 'mdi-sitemap'
        else {
          if(item.shared>1) return 'mdi-account-group'
          else if(item.shared===1) return 'mdi-account'
        }
      },
  
      openInfoForm(){
        this.formProps = {
          data: this.currentElement,
          type: this.elementType
        }
        this.currentComponent = InfoForm
        this.dialog = true
      },
      
      downloadFile(){
        if(this.currentElement.token){
          let url = '/disk/d/'+this.currentElement.token
          let anchor = document.createElement('a');
          anchor.href = url;
          anchor.target = '_blank';
          anchor.download = this.currentElement.name;
          anchor.click();
        } else {
          this.$dmsErrorNoty('Ошибка. Невозможно скачать файл.')
        }
      },
  
      saveDialog(eventData){
        switch(eventData.type){
          case 'addFile':
            this.addFile(eventData.data)
            break
          case 'saveFile':
            this.saveFile(eventData.data, eventData.change_owner)
            break
          case 'saveFolder':
            this.saveFolder(eventData.data, eventData.change_owner)
            break
          case 'scopes':
            this.saveScopes(eventData.data, eventData.count)
            break
          case 'change-history':
            this.changeVersion()
            break;
        }
        if(!eventData.dialog===true) this.dialog = false
      },
  
      addFile(file){
        let tree = null
        switch(this.currentTree){
          case 'my': tree = this.data; break
          case 'shared': tree = this.shared_files; break
          case 'trashed': tree = this.trashed_files; break
          default: tree = this.data; break
        }
        
        if(file.directory!=null){
          let newParent = getNodeByProp('key', 'directory_'+file.directory, tree)
          if(newParent!=null){
            newParent.children.push(file)
          }
        } else {
          tree.push(file)
        }
      },
      
      saveFile(file, change_owner){
        let tree = null
        switch(this.currentTree){
          case 'my': tree = this.data; break
          case 'shared': tree = this.shared_files; break
          case 'trashed': tree = this.trashed_files; break
          default: tree = this.data; break
        }
        if(change_owner){
          deleteNodeByProp('key', 'file_'+file.id, tree)
        } else {
          if(this.currentElement.directory === file.directory){
            Object.assign(this.currentElement, file)
          } else {
            deleteNodeByProp('key', 'file_'+file.id, tree)
            if(file.directory!=null){
              let newParent = getNodeByProp('key', 'directory_'+file.directory, tree)
              if(newParent!=null){
                newParent.children.push(file)
              }
            } else {
              tree.push(file)
            }
          }
        }
      },
  
      saveFolder(folder, change_owner){
        let tree = null
        switch(this.currentTree){
          case 'my': tree = this.data; break
          case 'shared': tree = this.shared_files; break
          case 'trashed': tree = this.trashed_files; break
          default: tree = this.data; break
        }
        
        if(change_owner){
          deleteNodeByProp('key', 'directory_'+folder.id, tree)
        } else {
          folder.children = this.currentElement.children
          //Если родитель не менялся - Обновить данные
          if(this.currentElement.parent === folder.parent){
            Object.assign(this.currentElement, folder)
          } else {
            // Если менялся родитель: Перенести, если папка уже видна. Если не видна - удалить текущую. Если null - втставить в корень
            deleteNodeByProp('key', 'directory_'+folder.id, tree)
            if(folder.parent!=null){
              let newParent = getNodeByProp('key', 'directory_'+folder.parent, tree)
              if(newParent!=null){
                let index = newParent.children.length
                newParent.children.some( (el, i) => {
                  if(el.key.indexOf('file')>-1){
                    index = i
                    return true
                  }
                })
                newParent.children.splice(index, 0, folder)
              }
            } else {
              let index = tree.length
              tree.some( (el, i) => {
                if(el.key.indexOf('file')>-1){
                  index = i
                  return true
                }
              })
              tree.splice(index, 0, folder)
            }
          }
        }
      },
  
      saveScopes(data, count){
        data.shared = count
      },
      
      openEditForm(editMode){
        let tree = null
        switch(this.currentTree){
          case 'my': tree = this.data; break
          case 'shared': tree = this.shared_files; break
          case 'trashed': tree = this.trashed_files; break
          default: tree = this.data; break
        }
        
        this.formProps = {
          isFolder: editMode && this.elementType==='folder',
          editMode: editMode
        }
        //EditMode = false может быть только у файла
        if(editMode===false){
          this.formProps.data = {
            name : '',
            directory: this.currentElement.id,
            dir_name: this.currentElement.name
          }
        } else {
          this.formProps.data = this.currentElement
          let key = (this.elementType==='folder') ? this.currentElement.parent : this.currentElement.directory
          let node = getNodeByProp('key', 'directory_'+key, tree)
          if(node!=null){
            this.formProps.data.dir_name = node.name
          }
        }
        this.currentComponent = FolderForm
        this.dialog = true
      },
  
      makeBreadCrumbs(item = null){
        let root = {}
        let tree = null
        switch(this.currentTree) {
          case 'shared':
            root = {
              id: -2,
              name: 'Доступные мне',
              children: this.shared_files
            }
            tree = this.shared_files
            break
          case 'trashed':
            root = {
              id: -3,
              name: 'Корзина',
              children: this.trashed_files
            }
            tree = this.trashed_files
            break
          default:
            root = {
              id: item == null ? this.disks.find(x => x.type === 'system').id : this.disks.find(x => x.id === item.volume).id ,
              name: item == null ? 'Мой диск' : this.disks.find(x => x.id === item.volume).label,
              children: this.data
            }
            tree = this.data
            break
        }
        this.breadCrumbs = []

        if(item){
          this.breadCrumbs = [item]
          let temp = item
          if(temp.key.indexOf('file')>-1){
            temp.parent = temp.directory
          }
          while(temp !== null && temp.parent !== null){
            if(temp.key.indexOf('directory')>-1){
              temp = getNodeByProp('key', 'directory_'+temp.parent, tree)
            } else {
              temp = getNodeByProp('key', 'directory_'+temp.directory, tree)
            }
            if(temp!=null) {
              this.breadCrumbs.unshift(temp)
            }
          }
        }
        this.breadCrumbs.unshift(root)
      },
  
      navigateCrumb(index){
        if(index!==this.breadCrumbs.length-1){
          this.editFile = false
          this.breadCrumbs.splice(index+1)
          this.folderContent = this.breadCrumbs[index].children
          this.clearPreview()
          this.getOwners()
        }
      },
      
      previewFile(){
        this.editFile = false
        this.preview = true
        this.previewElement = JSON.parse(JSON.stringify(this.currentElement))
      },
      
      clearPreview(){
        this.preview = false
        this.previewElement = null
      },
      
      clearEdit() {
        if( this.socket ) {
          this.socket.close()
        }
        this.socket = null
        this.node = null
        this.offset = 0
        this.connectedUsers = null
        
        this.maySave = false
        this.editFile = false
        this.fileContent = ''
      },
      
      formatFileSize(bytes) {
        if(isNaN(bytes)) return '-'
        if(bytes===0) return ' 0 Б'
        let k = 1000,
          dm = 2,
          sizes = ['Б', 'Кб', 'Мб', 'Гб', 'Тб', 'Пб'],
          i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
      },
  
      deleteTrash(){
        this.$dmsAgree('Файлы будут удалены безвозвартно. Вы действительно хотите очистить корзину?').then(_ => {
          this.$store.dispatch('disk/deleteTrash').then( response => {
            this.$dmsSuccessNoty('Корзина успешно очищена')
          }).catch( error => {
            this.$dmsErrorNoty('Возникла ошибка при очистке корзины')
          })
        })
      },
  
      restoreElement(){
        let type = (this.currentElement.key.indexOf('directory')>-1) ? 'directory' : 'file'
        this.$store.dispatch('disk/recover', {id: this.currentElement.id, type}).then( response => {
          let node = deleteNodeByProp('key', this.currentElement.key, this.trashed_files)
          if(node!=null){
            if(node.key.indexOf('file')>-1){
              this.data.push(node)
            } else {
              let index = this.data.length
              this.data.some( (el, i) => {
                if(el.key.indexOf('file')>-1){
                  index = i
                  return true
                }
              })
              this.data.splice(index, 0, node)
            }
          }
        }).catch( error => {
          this.$dmsErrorNoty('Возникла ошибка при попытке восстановления')
        })
      },
  
      selectInputFile(tree) {
        this.currentTree = tree
        if (this.$refs && this.$refs.file) {
          this.$refs.file.click()
        }
      },
  
      onChangeInputFile(e){
        let files = e.target.files || e.dataTransfer.files
        if (!files.length) return
        let formData = new FormData
        formData.append("file", files[0]);
        formData.append('name', files[0].name)
        formData.append('volume', this.currentElement.volume)
        if(this.currentElement && this.currentElement.key.indexOf('directory')>-1){
          formData.append('directory', this.currentElement.id)
        }
        this.loadingDialog = true

        this.cancelTokenSource = cancelToken.source()
        apiDisk.uploadFile(formData, this.cancelTokenSource.token).then( response => {
          this.addFile(response)
        }).catch( error => {
          let message = (error.message && error.message.length>0) ? error.message : 'Ошибка загрузки файла'
          this.$dmsErrorNoty(message)
        }).finally( _ => {
          this.loadingDialog = false
          this.cancelTokenSource = null
        })
      },
  
      cancelFileUploading(){
        this.cancelTokenSource.cancel('Загрузка файла отменена пользователем')
        this.loadingDialog = false
        this.cancelTokenSource = null
      },
      
      getOwners(){
        //Если дерево доступных - получить пост и фио владельца, если корзина или моя файлы - я владелец
        if(this.currentTree==='shared'){
          let posts = []
          this.folderContent.map( el => {
            let post = this.getPostById(el.owner.post_id)
            if(post.loaded){
              this.$set(el.owner, 'name', post.name)
              this.$set(el.owner, 'fullname', post.fullname)
            } else if(!posts.includes(el.owner.post_id)){
              posts.push(el.owner.post_id)
            }
          })
          if(posts.length>0){
            this.$store.dispatch('app/org/entitiesInfo', { posts, containers: [] }).then( response => {
              this.$store.commit('app/org/addPosts', response.posts_data)
              this.folderContent.map( el => {
                let post = this.getPostById(el.owner.post_id)
                if(post.loaded){
                  this.$set(el.owner, 'name', post.name)
                  this.$set(el.owner, 'fullname', post.fullname)
                }
              })
            })
          }
        } else {
          this.folderContent.map( el => {
            this.$set( el.owner, 'name', this.curPost.name )
            this.$set( el.owner, 'fullname', this.userFullName )
          } )
        }
      },
  
      openHistoryForm(){
        this.currentComponent = HistoryForm
        this.formProps = { data: this.currentElement }
        this.dialog = true
      },
      
      changeVersion(){
        this.loading = true
        this.$store.dispatch('disk/getFileContent', this.currentElement.id).then(response => {
          this.fileContent = response
          this.loading = false
        })
      },
  
      leaving(event){
        if(this.maySave){
          let text = `Имеются несохраненные изменения`
          event.returnValue = text
          return text
        } else {
          return false
        }
      },

      tipTapContentChanged(changedHtml){
        this.fileContent = changedHtml
        this.maySave = true
        this.saveContentDebounce()
      },

      contentChanged(){
        this.maySave = true
        this.saveContentDebounce()
      },
      
      openSocketConnection( file_id ) {
        let token = this.$store.getters['app/account/getAuthTokens'].access_token
        let post_id = this.$store.state.app.account.postId
        
        this.socket = new WebSocket( `wss://${location.host}/ws/private/disk/v1/file/bind/${file_id}/?token=${token}&post_id=${post_id}` )
        //this.socket = new WebSocket(`wss://10.99.0.171/ws/file/bind/${file_id}/`)
        
        this.socket.onmessage = ( event ) => {
          this.onSocketMessage( JSON.parse(event.data) )
        }
        let avatar = this.$store.state.app.account.anketa.photo
        let name = this.curPost.name+' ('+this.userFullName+')'
        this.socket_id = uuidv4()
        let init_data = {
          name,
          avatar
        }
        this.socket.onopen = () => {
          this.socket.send( `{"type":"init", "init_data":${JSON.stringify(init_data)}, "connection_id": "${this.socket_id}"}` )
        }
        this.socket.onerror = (event) => {
          this.$dmsErrorNoty('Возникла ошибка при попытке соединения')
        }
      },
  
      onSocketMessage(data){
        switch(data.type){
          case 'init':
            for(let key in data.users){
              if(data.users[key].avatar && data.users[key].avatar.indexOf('base64')<0 && data.users[key].avatar.indexOf('http')<0 && data.users[key].avatar.length>0){
                data.users[key].avatar = '/disk/d/'+data.users[key].avatar
              }
            }
            this.connectedUsers = data.users
            break
          case 'insert_text':
            if(data.connection_id && data.connection_id!==this.socket_id){
              if(data.type==='insert_text' && data.xpath){
                let node = this.getElementByXPath(data.xpath)
                switch(data.content_type){
                  case 'text':
                    node.innerHTML = data.content
                    break
                  case 'outer':
                    node.outerHTML = data.content
                    break
                  case 'node':
                    let div = document.createElement('div')
                    div.innerHTML = data.content.trim()
                    while(div.children.length>0){
                      let child = div.lastChild
                      node.parentNode.insertBefore(child, node.nextSibling);
                    }
                    break
                  case 'command':
                    this.$refs.editor.editor.selection.select(node)
                    this.userCommand = false
                    this.$refs.editor.editor.execCommand(data.content)
                    this.userCommand = true
                    break
                }
              }
            }
            break
          case 'close_connection':
            if(this.connectedUsers[data.user]){
              if(this.curPost.id!==data.user) this.$delete(this.connectedUsers, data.user)
            }
            break
          default:
            
            break
        }
        
      },
  
      nodeChange( e ) {
        if( e.selectionChange && e.element.tagName!=='BODY') {
          let range = e.target.selection.getRng()
          let node = e.target.selection.getNode()
          this.offset = range.startOffset
          if(this.node!==node && this.node!=null){
            let xpath = this.getXPathForElement(this.node)
            let data = `{"type":"insert_text", "xpath":"${xpath}", "content_type": "text", "content":${JSON.stringify(this.node.innerHTML)}, "connection_id": "${this.socket_id}"}`
            this.sendContent(data, 'change - text')
        
            if(this.enter){
              let dataEnter = `{"type":"insert_text", "xpath":"${xpath}", "content_type": "node", "content":${JSON.stringify(node.outerHTML)}, "connection_id": "${this.socket_id}"}`
              this.contentSent = false
              this.sendContent(dataEnter, 'change enter')
            }
            this.enter = false
          }
          this.node = node
        }
      },
  
      onPaste(event){
        let content = event.clipboardData.getData('text/html')
        let range = this.$refs.editor.editor.selection.getRng()
        let ancestor = (range.commonAncestorContainer.nodeType === 3) ? range.commonAncestorContainer.parentNode : range.commonAncestorContainer
    
        let xpath = this.getXPathForElement(ancestor)
        let data = `{"type":"insert_text", "xpath":"${xpath}", "content_type": "node", "content":${JSON.stringify(content)}, "connection_id": "${this.socket_id}"}`
        this.contentSent = false
        this.sendContent(data, 'paste event')
      },
      
      keyDown( event ) {
        //keyDown - потому что нужно получить контент ДО нажатия клавиши. Не обрабатывать, если выделена область (существует rangeAncestor) - в этом случает должен сработать keyUp
        /*if(!this.rangeAncestor && event.which === 13){
          this.enter = true
          this.contentSent = false
          if(this.offset === 0){
            let node = this.node.previousSibling
            let xpath = this.getXPathForElement(node)
            let data = `{"type":"insert_text", "xpath":"${xpath}", "content_type": "node", "content":${JSON.stringify(node.outerHTML)}, "connection_id": "${this.socket_id}"}`
            this.sendContent(data, 'keydown enter')
            this.enter = false
          }
        }*/
      },
      
      keyUp(event){
        if(!this.rangeAncestor){
          this.contentSent = false
          if( event.which > 31 || event.which === 8 ) {
            this.node = this.$refs.editor.editor.selection.getNode()
            this.sendContentThrottle()
          } else if(event.which === 13){
            this.enter = true
            this.contentSent = false
            if(this.offset === 0){
              let node = this.node
              let xpath = this.getXPathForElement(node.previousSibling)
              let data = `{"type":"insert_text", "xpath":"${xpath}", "content_type": "node", "content":${JSON.stringify(node.outerHTML)}, "connection_id": "${this.socket_id}"}`
              this.sendContent(data, 'keydown enter')
              this.enter = false
            }
          }
        } else if(this.rangeAncestor && (event.which>31 || event.which === 8 || event.which === 13)){
          //Если выделен промежуток контента и нажата клавиша, приводящая к изменению контента.
          let ancestor = this.rangeAncestor
          if(ancestor.nodeName!=="BODY") ancestor = ancestor.parentElement
          let xpath = this.getXPathForElement(ancestor)
          let data = `{"type":"insert_text", "xpath":"${xpath}", "content_type": "text", "content":${JSON.stringify(ancestor.innerHTML)}, "connection_id": "${this.socket_id}"}`
          this.contentSent = false
          this.sendContent(data, 'keyup selection')
          this.rangeAncestor = null
        }
      },
  
      mouseUp(event){
        let range = this.$refs.editor.editor.selection.getRng()
        if(range.startContainer!==range.endContainer){
          this.rangeAncestor = (range.commonAncestorContainer.nodeType === 3) ? range.commonAncestorContainer.parentNode : range.commonAncestorContainer
        } else {
          this.rangeAncestor = null
        }
      },
  
      beforeExecCommand(event){
        let exec = false
        let content = null, content_type = null
        let range = this.$refs.editor.editor.selection.getRng()
        let ancestor = (range.commonAncestorContainer.nodeType === 3) ? range.commonAncestorContainer.parentNode : range.commonAncestorContainer
        
        switch(event.command){
          case 'mceInsertContent':
            //Вставка таблицы
            if(event.value.indexOf('<table')>=0){
              if(range.endContainer.textContent.length===range.endOffset && range.endOffset!==0){ // Вставка в конце элемента
                content = event.value
                content_type = 'node'
              } else if(range.endOffset===0){ // Вставка в начале элемента. После предыдущего, или в самом начале родительског оконтейнера, если не существует предыдущего
                if(ancestor.previousSibling!=null){
                  ancestor = ancestor.previousSibling
                  content = event.value
                  content_type = 'node'
                } else if(ancestor.nodeName!=="BODY"){
                  ancestor = ancestor.parentElement
                  content = event.value+ancestor.innerHTML
                  content_type = 'text'
                }
              } else { // Вставка в середине элемента
                if(ancestor.nodeName!=="BODY") ancestor = ancestor.parentElement
                content = ancestor.innerHTML
                content_type = 'text'
              }
              exec = true
            }
            break
          case 'mceTableInsertRowBefore':
          case 'mceTableInsertRowAfter':
          case 'mceTableInsertColBefore':
          case 'mceTableInsertColAfter':
          case 'mceTableDeleteCol':
          case 'mceTableDeleteRow':
          case 'mceTableDelete':
            exec = true
            content_type = 'command'
            content = event.command
            break
          case "Indent":
          case "Outdent":
            exec = true
            content_type = 'command'
            content = event.command
            break
        }
        if(exec && content!=null && content_type!=null && this.userCommand){
          let xpath = this.getXPathForElement(ancestor)
          let data = `{"type":"insert_text", "xpath":"${xpath}", "content_type": "${content_type}", "content":${JSON.stringify(content)}, "connection_id": "${this.socket_id}"}`
          this.contentSent = false
          this.sendContent(data, 'before exec')
        }
      },
  
      execCommand(event){
        let exec = false
        let range = this.$refs.editor.editor.selection.getRng()
        let ancestor = (range.commonAncestorContainer.nodeType === 3) ? range.commonAncestorContainer.parentNode : range.commonAncestorContainer
        let content_type = "text"
        
        switch(event.command){
          case "Indent":
          case "Outdent":
            //ancestor = this.node
            
            //exec = true
            //content_type = "outer"
            break
            
          case "mceToggleFormat":
            if(ancestor.nodeName!=="BODY")
              ancestor = ancestor.parentNode
            content_type = "outer"
            exec = true
            break
          case "JustifyLeft":
          case "JustifyCenter":
          case "JustifyRight":
          case "JustifyFull":
            content_type = "outer"
            exec = true
            break
          case "InsertHorizontalRule":
            if(ancestor.nodeName!=="BODY")
              ancestor = ancestor.parentNode
            exec = true
            break
          case "InsertUnorderedList":
          case "InsertOrderedList":
            //Если Selection - Выбрать родительский тег над Создаваемым или удаляемым OL/UL
            if(ancestor.nodeName!=="BODY")
              ancestor = ancestor.parentNode
            //Если Selection нет - Родительский тег будет li, поэтому нужно взять еще на 1 уровень выше
            if(range.endContainer === range.startContainer && range.startOffset === range.endOffset && ancestor.nodeName!=="BODY")
              ancestor = ancestor.parentNode
            exec = true
            break
        }
        
        if(exec && this.userCommand){
          let xpath = this.getXPathForElement(ancestor)
          let content = (content_type==="outer") ? JSON.stringify(ancestor.outerHTML) : JSON.stringify(ancestor.innerHTML)
          let data = `{"type":"insert_text", "xpath":"${xpath}", "content_type": "${content_type}", "content":${content}, "connection_id": "${this.socket_id}"}`
          this.contentSent = false
          this.sendContent(data, 'exec command')
        }
        
      },
  
      sendContent(data, src){
        if(!this.contentSent){
          this.socket.send( data )
        }
        this.contentSent = true
      },
      
      getXPathForElement( element ) {
        const idx = ( sib, name ) => sib
          ? idx( sib.previousElementSibling, name || sib.localName ) + (sib.localName == name)
          : 1;
        const segs = elm => !elm || elm.nodeType !== 1
          ? [ '' ]
          : elm.id && document.querySelector( `#${elm.id}` ) === elm
            ? [ `id("${elm.id}")` ]
            : [ ...segs( elm.parentNode ), `${elm.localName.toLowerCase()}[${idx( elm )}]` ]
        
        return segs( element ).join( '/' )
      },
      
      getElementByXPath( path ) {
        return (new XPathEvaluator())
        .evaluate( path, document.getElementsByTagName('iframe')[0].contentWindow.document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null ).singleNodeValue
      },

      pushToTrash(node) {
        this.trashed_files.push(node)
      },

      pushFolderToTrash(node) {
        this.trashed_files.unshift(node)
      },

      makeCurrentElement(response, tree) {
        this.currentElement = response
        this.data = tree
        this.treeOpen.push('directory_'+response.directory)
        this.makeBreadCrumbs(response)
        this.itemClick(response)
      },

      letData(response) {
        this.data = response
      }
    },
  }
</script>

<style>
  .zi-10{
    z-index: 10;
  }
  .treeblock .v-treeview.densed .v-treeview-node__root{
    height:25px !important;
  }
  .treeblock .v-treeview.densed .v-treeview-node__root .v-treeview-node__label{
    font-size: 14px;
  }
  #disk-context-menu ul.ctx-menu li{
    padding: 6px 7px 6px 10px;
    cursor: pointer;
    font-size: 14px;
  }
  #disk-context-menu ul.ctx-menu li:hover{
    background: #e4e4e4;
  }
  #disk-context-menu ul.ctx-menu li i{
    width: 20px;
  }
  #disk-files-table td, #disk-files-table th{
    padding: 3px 5px;
    height: auto;
  }
  .dms-disk-file{
    float: left;
    width: 110px;
    text-align: center;
    margin: 3px;
    padding: 2px;
    cursor: pointer;
  }
  .dms-disk-file:hover{
    background: #cacaca;
  }
  .disk-file-icon i.mdi{
    font-size: 60px;
    line-height: 60px;
  }
  .disk-file-name p{
    line-height: 1em;
    height: 2em;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
    margin: 0;
    font-size: 13px;
  }
  ul.dms-breadcrumb {
    padding: 6px;
    list-style: none;
  }
  ul.dms-breadcrumb li {
    display: inline;
    font-size: 14px;
  }
  ul.dms-breadcrumb li+li:before {
    padding: 3px;
    color: inherit;
    content: "/";
  }
  ul.dms-breadcrumb li a {
    color: #0275d8;
    text-decoration: underline;
  }
  ul.dms-breadcrumb li:last-child a, ul.dms-breadcrumb li:last-child a:hover{
    text-decoration: none;
    color: inherit;
    cursor: default;
  }
  ul.dms-breadcrumb li a:hover {
    color: #01447e;
    text-decoration: none;
  }
  .d-file-uploader__input {
    opacity: 0;
    visibility: hidden;
    position: absolute;
    width: 0.1px;
    height: 0.1px;
    overflow: hidden;
    z-index: -1;
  }
</style>


// WEBPACK FOOTER //
// src/apps/disk/components/Folders/FoldersList.vue